// import React, { useState, useRef, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import "./Auth.css";

// const OTPVerification = () => {
//   const [otp, setOtp] = useState(["", "", "", "", "", ""]);
//   const [timer, setTimer] = useState(60);
//   const [canResend, setCanResend] = useState(false);
//   const inputRefs = useRef([]);
//   const location = useLocation();
//   const { email } = location?.state;
//   console.log(location.state.email, "emai");

//   useEffect(() => {
//     // Timer countdown
//     if (timer > 0) {
//       const interval = setInterval(() => {
//         setTimer((prev) => prev - 1);
//       }, 1000);
//       return () => clearInterval(interval);
//     } else {
//       setCanResend(true);
//     }
//   }, [timer]);

//   const handleChange = (index, value) => {
//     // Only allow numbers
//     if (!/^\d*$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     // Move to next input if value is entered
//     if (value && index < 5) {
//       inputRefs.current[index + 1].focus();
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     // Move to previous input on backspace if current input is empty
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       inputRefs.current[index - 1].focus();
//     }
//   };

//   const handlePaste = (e) => {
//     e.preventDefault();
//     const pastedData = e.clipboardData.getData("text").slice(0, 6);
//     if (!/^\d+$/.test(pastedData)) return;

//     const newOtp = [...otp];
//     pastedData.split("").forEach((char, index) => {
//       if (index < 6) {
//         newOtp[index] = char;
//       }
//     });
//     setOtp(newOtp);

//     // Focus on the last filled input or the next empty one
//     const nextIndex = Math.min(pastedData.length, 5);
//     inputRefs.current[nextIndex].focus();
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const otpValue = otp.join("");
//     if (otpValue.length === 6) {
//       console.log("OTP submitted:", otpValue);
//       // Add your OTP verification logic here
//     } else {
//       alert("Please enter complete OTP");
//     }
//   };

//   const handleResend = () => {
//     if (canResend) {
//       console.log("Resending OTP...");
//       setTimer(60);
//       setCanResend(false);
//       setOtp(["", "", "", "", "", ""]);
//       inputRefs.current[0].focus();
//       // Add your resend OTP logic here
//     }
//   };

//   return (
//     <div className="auth-container">
//       <div className="auth-wrapper otp-wrapper">
//         {/* Left Side - Image/Brand Section */}
//         <div className="auth-image-section">
//           <div className="auth-brand-content">
// //             <p className="auth-brand-tagline">NATURAL THREADS. HISTORY AHEAD</p>
//             <div className="auth-decorative-icons">
//               <svg
//                 width="80"
//                 height="80"
//                 viewBox="0 0 100 100"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//               >
//                 <ellipse cx="50" cy="35" rx="20" ry="25" />
//                 <path d="M 30 35 Q 30 50 50 60 Q 70 50 70 35" />
//                 <circle cx="45" cy="32" r="2" fill="currentColor" />
//                 <circle cx="55" cy="32" r="2" fill="currentColor" />
//                 <path d="M 45 38 Q 50 40 55 38" strokeLinecap="round" />
//               </svg>
//             </div>
//           </div>
//         </div>

//         {/* Right Side - OTP Form */}
//         <div className="auth-form-section">
//           <div className="auth-form-container">
//             <div className="otp-icon">
//               <svg
//                 width="60"
//                 height="60"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="#e89b7c"
//                 strokeWidth="2"
//               >
//                 <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
//                 <polyline points="22,6 12,13 2,6" />
//               </svg>
//             </div>

//             <h2 className="auth-form-title">Verify Your Email</h2>
//             <p className="auth-form-subtitle">
//               We've sent a 6-digit verification code to
//             </p>
//             <p className="auth-email-display">{email}</p>

//             <form onSubmit={handleSubmit} className="auth-form otp-form">
//               <div className="otp-input-group">
//                 {otp.map((digit, index) => (
//                   <input
//                     key={index}
//                     ref={(el) => (inputRefs.current[index] = el)}
//                     type="text"
//                     maxLength="1"
//                     value={digit}
//                     onChange={(e) => handleChange(index, e.target.value)}
//                     onKeyDown={(e) => handleKeyDown(index, e)}
//                     onPaste={handlePaste}
//                     className="otp-input"
//                     autoFocus={index === 0}
//                   />
//                 ))}
//               </div>

//               <div className="otp-timer">
//                 {canResend ? (
//                   <button
//                     type="button"
//                     onClick={handleResend}
//                     className="resend-link"
//                   >
//                     Resend Code
//                   </button>
//                 ) : (
//                   <p>
//                     Resend code in <span className="timer-count">{timer}s</span>
//                   </p>
//                 )}
//               </div>

//               <button type="submit" className="auth-submit-btn">
//                 Verify & Continue
//               </button>

//               <Link to="/login" className="back-to-login">
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <line x1="19" y1="12" x2="5" y2="12" />
//                   <polyline points="12 19 5 12 12 5" />
//                 </svg>
//                 Back to Login
//               </Link>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OTPVerification;

import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import authService from "../services/authService";
import { useAuth } from "../context/AuthContext";
import "./Auth.css";

const OTPVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);

  const email = location?.state?.email;
  const firstName = location?.state?.firstName;

  // Redirect if no email
  useEffect(() => {
    if (!email) {
      toast.error("Invalid access. Please signup again.");
      navigate("/signup");
    }
  }, [email, navigate]);

  useEffect(() => {
    // Timer countdown
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const handleChange = (index, value) => {
    // Only allow numbers
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input if value is entered
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Move to previous input on backspace if current input is empty
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, 6);
    if (!/^\d+$/.test(pastedData)) return;

    const newOtp = [...otp];
    pastedData.split("").forEach((char, index) => {
      if (index < 6) {
        newOtp[index] = char;
      }
    });
    setOtp(newOtp);

    // Focus on the last filled input or the next empty one
    const nextIndex = Math.min(pastedData.length, 5);
    inputRefs.current[nextIndex].focus();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");

    if (otpValue.length !== 6) {
      toast.error("Please enter complete OTP");
      return;
    }

    try {
      setLoading(true);

      const response = await authService.verifyOTP({
        email,
        otp: otpValue,
      });

      if (response?.token) {
        toast.success(response.message || "Email verified successfully!");

        // Log the user in
        login(response.token, response.user);

        // Navigate to home page
        navigate("/");
      } else {
        toast.error(response?.message || "Invalid OTP");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Invalid OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (!canResend) return;

    try {
      setLoading(true);

      const response = await authService.resendOTP({ email });

      if (response?.success || response?.message) {
        toast.success("OTP sent successfully!");
        setTimer(60);
        setCanResend(false);
        setOtp(["", "", "", "", "", ""]);
        inputRefs.current[0].focus();
      } else {
        toast.error("Failed to resend OTP");
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to resend OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-wrapper otp-wrapper">
        {/* Left Side - Image/Brand Section */}
        <div className="auth-image-section">
          <div className="auth-brand-content">
            <img src="/images/final_logo.png" alt="Kitty N' Mice" className="auth-logo" />
            <p className="auth-brand-tagline">NATURAL THREADS. HISTORY AHEAD</p>
            <div className="auth-decorative-icons"></div>
          </div>
        </div>

        {/* Right Side - OTP Form */}
        <div className="auth-form-section">
          <div className="auth-form-container">
            <div className="otp-icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#e89b7c"
                strokeWidth="2"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </div>

            <h2 className="auth-form-title">Verify Your Email</h2>
            <p className="auth-form-subtitle">
              {firstName && `Hi ${firstName}! `}
              We've sent a 6-digit verification code to
            </p>
            <p className="auth-email-display">{email}</p>

            <form onSubmit={handleSubmit} className="auth-form otp-form">
              <div className="otp-input-group">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    onPaste={handlePaste}
                    className="otp-input"
                    autoFocus={index === 0}
                    disabled={loading}
                  />
                ))}
              </div>

              <div className="otp-timer">
                {canResend ? (
                  <button
                    type="button"
                    onClick={handleResend}
                    className="resend-link"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Resend Code"}
                  </button>
                ) : (
                  <p>
                    Resend code in <span className="timer-count">{timer}s</span>
                  </p>
                )}
              </div>

              <button
                type="submit"
                className="auth-submit-btn"
                disabled={loading || otp.join("").length !== 6}
              >
                {loading ? (
                  <>
                    <span className="spinner-small"></span>
                    Verifying...
                  </>
                ) : (
                  "Verify & Continue"
                )}
              </button>

              <Link to="/signup" className="back-to-login">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="19" y1="12" x2="5" y2="12" />
                  <polyline points="12 19 5 12 12 5" />
                </svg>
                Back to Signup
              </Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;
